export default "__VITE_ASSET__BTPtwNBw__"